import './App.css';
import Login from './pages/Login/Login';
import Register from './pages/Register';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Cookies from "js-cookie";
import { refreshSSOToken } from './utils/auth';

import ProtectedRoute from "./pages/ProtectedRoute";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!Cookies.get("accessToken"));

  useEffect(() => {
    const interval = setInterval(async () => {
      const hasToken = !!Cookies.get("accessToken");
      if (!hasToken && localStorage.getItem('refresh_token')) {
        const ok = await refreshSSOToken();
        setIsAuthenticated(ok);
      } else {
        setIsAuthenticated(hasToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={isAuthenticated ? <Navigate to="/homepage" /> : <Login />} />
          <Route path="/*" element={<ProtectedRoute />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
